<template>
  <aside class="popup popup-padding add-permission-project">
    <header class="popup-top">
      <h2 class="title">
        {{$t('btns.things.addThing')}}
      </h2>
      <div class="popup-top_btns">
        <close-btn class="static"></close-btn>
      </div>

    </header>
    <form class="add-permission-form"
          @submit.prevent="addThings">
      <div class="select-cont select-cont_multiple">
        <p class="label">
          {{$t('btns.things.addThing')}}
        </p>
        <v-select multiple
                  :searchable="true"
                  :clearable="false"
                  label="name"
                  v-model="things"
                  :options="thingsFirst"></v-select>
      </div>
      <div class="btns-bottom">
        <button type="button"
                :disabled="loading"
                @click="closeAll"
                class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
        <button type="submit"
                :disabled="loading || disabled"
                :class="{'loading': loading}"
                class="btn btn-blue">{{$t('btns.add')}}</button>
      </div>
    </form>
  </aside>
</template>

<script>
  import closeBtn from '../closeBtn'
  import {mapState, mapActions} from 'vuex'
  import {popups} from "../../../mixins/popups";
  import {toFormData} from "../../../mixins/utils/toFormData";

  export default {
    name: 'addThingProject',
    components: {
      closeBtn
    },
    mixins: [popups,toFormData],
    data() {
      return {
        things: [],
        loading: false,
      }
    },
    computed: {
      ...mapState({
        allThingsFromGetOwned: state => state.things.allThingsFromGetOwned
      }),
      disabled() {
        return this.things.length < 1
      },
      thingsFirst() {
        let arr = [];
        let parentId = Number(this.$route.params.id);

        let searchParent = (items) => {
          items.forEach((item) => {
            if (item.parent_device_id !== null && item.id === parentId) {
              parentId = item.parent_device_id;
              searchParent(this.allThingsFromGetOwned);
            }
          })
        }

        searchParent(this.allThingsFromGetOwned)

        arr = this.allThingsFromGetOwned.filter(item => !item.parent_device_id && item.id !== parentId).map(item => {
          return {
            id: item.id,
            name: item.name
          }
        })

        arr.sort((a, b) => {
          if (a.name < b.name) {
            return -1
          }
          if (a.name > b.name) {
            return 1
          }
          return 0
        })

        return arr
      },
    },
    methods: {
      ...mapActions({
        addDeviceInProject: 'projects/addDeviceInProject',
        getProject: 'projects/getProjects',
        getOwned: 'things/getDevices',
        updateThing: 'things/updateDevice',

      }),
      async addThings() {
        this.loading = true;

        if (this.$route.name === 'virtualThingList') {
          for (let thing of this.things) {
            let data = {
              device_id: thing.id,
              parent_device_id: this.$route.params.id
            };
            let formData = this.toFormData(data);
            await this.updateThing(formData)
          }
          this.loading = false;
          this.closeAll();
        } else {
          for (let thing of this.things) {
            await this.addDeviceInProject({
              data: {
                device_id: thing.id,
                project_item_id: this.$route.params.item
              }
            });
          }
          this.getProject(this.$route.params.id);
          this.getOwned();
          this.loading = false;
          this.closeAll();
        }
      }
    }
  }
</script>

<style lang="scss">
  .vs__selected {
    max-width: 90%;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>

<style lang="scss" scoped>
  .permission-toggler {
    margin: 15px 0;
  }
</style>
